import widgetLoader from 'dibs-widget-loader';
import { getBuyerId } from 'dibs-cookie-jar';

export function loadSocialNetworks({ relayEnvironment }) {
    const hasUserId = !!getBuyerId(document.cookie);

    if (!hasUserId) {
        widgetLoader.load('google', { relayEnvironment });
        widgetLoader.load('facebook', { relayEnvironment });
        widgetLoader.load('apple', { relayEnvironment });
    }
}
